export { default as ContentWrapOutlineIcon } from './ContentWrapOutlineIcon';
